import { Stack, Container } from '@mui/material';

import useResponsive from '../../hooks/useResponsive';
import useEmbedded from "../../hooks/useEmbedded";
import AuthWelcomeBanner from './AuthWelcomeBanner';
import { LoginForm } from '../../sections/auth/login';
import { SectionStyle, ContentStyle } from './styles';
import { AppGridContainer, AppGridContent } from 'src/components';

//
//

export default function Login() {
  const mdUp = useResponsive('up', 'md');
  const { isEmbedded } = useEmbedded();

  return (
      <Container maxWidth={false}>

        <AppGridContainer alignItems="center">
          {mdUp && !isEmbedded && (
            <SectionStyle size={{ xs: 12, md: 6 }}>
              <AuthWelcomeBanner type="login" />
            </SectionStyle>
          )}
          <AppGridContent size={{ xs: 12, md: 6 }}>
            <ContentStyle isEmbedded={isEmbedded}>
              <Stack spacing={{ xs: 4, sm: 6 }}>
                <LoginForm />
              </Stack>
            </ContentStyle>
          </AppGridContent>
        </AppGridContainer>

      </Container>
  );
}
